import { ReactElement, ReactNode } from 'react';
import { ControlledTableProps, ControlledTableColumns, KeyGetter, RowType, SizeProps } from './types';
import { ControlledTable } from './ControlledTable';
import { useSessionScope } from 'services';

export type IndexTableProps<R extends RowType> = {
  url: string;
  filterFields?: ReactNode;
  columns: ControlledTableColumns<R>;
  before?: ReactNode;
  footer?: ReactNode;
  after?: ReactNode;
  // This is convoluted but we use null to disable storage
  storageKey?: string | null;
  pageSize?: number;
} & Pick<ControlledTableProps<R>, 'defaultFilter' | 'queryParams' | 'renderTable' | 'tableProps' | 'urlSync'>;

export function IndexTable<R extends RowType>({
  url,
  filterFields,
  before,
  // use url as storageKey if we have filters
  // FIXME: probably not safe
  storageKey = filterFields !== null ? url : undefined,
  pageSize: providedPageSize,
  after,
  footer,
  tableProps,
  columns,
  ...rest
}: IndexTableProps<R>): ReactElement {
  const { slug } = useSessionScope();
  const getKey: KeyGetter = ({ filter, pageSize, pageIndex, sort, queryParams }) => {
    return {
      url,
      method: 'GET',
      queryParams: {
        // FIXME
        ...filter,
        page_size: pageSize,
        page: pageIndex,
        ordering: sort ? `${sort.direction === 'DESC' ? '-' : ''}${sort.key.replace('.', '__')}` : undefined,
        ...queryParams,
      },
      _slug: slug,
    };
  };

  const sizeProps: SizeProps = providedPageSize ? { pageSize: providedPageSize } : { defaultPageSize: 30 };
  return (
    <ControlledTable<R>
      // remount
      key={url}
      {...sizeProps}
      getKey={getKey}
      columns={columns}
      storageKey={storageKey === null ? undefined : storageKey}
      filterFields={filterFields}
      before={before}
      tableProps={{
        size: 'sm',
        fontSize: 'sm',
        hover: true,
        fixed: false,
        footer,
        containerClassName: 'mb-2',
        after,
        ...tableProps,
      }}
      {...rest}
    />
  );
}
